var base = require('auth/register-stripe');

Vue.component('spark-register-stripe', {
    mixins: [base],
    mounted() {
      if (this.query && this.query.email) {
        this.registerForm.email = this.query.email;
      }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/spark-components/auth/register-stripe.js